/**
 * useTrackerBlockedReason — why a tracker's own Flow Optimizer switch keeps
 * its scheduler and Apply from pushing (Tres Commas: off by default), or
 * null. For NOTICES only: it is null under the global switch (that has its
 * own banner) and while the status has not answered — decisions use
 * useTrackerHold, which masks nothing. Same query (key and request) as the
 * Scheduler page; Voluum and Binom have no such switch: no request for them.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { TrackerId } from '@trafficpulse/shared';

import { useTrackerHold } from './useTrackerHold';

export function useTrackerBlockedReason(id: TrackerId, enabled = true): string | null {
  const hold = useTrackerHold(id, enabled);
  return hold.global ? null : hold.reason;
}
